module.exports = __webpack_public_path__ + "digirati-logo-white.bb26f17a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logos/digirati-logo-white.svg
// module id = O615
// module chunks = 0